
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/use-cases/banking-and-brokerage/account-onboarding",
      function () {
        return require("private-next-pages/use-cases/banking-and-brokerage/account-onboarding.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/use-cases/banking-and-brokerage/account-onboarding"])
      });
    }
  